/* eslint-disable */
import ggRouter from 'ggApp/modules/router';
import ggOrder from 'ggApp/modules/order';

import { Component, } from 'react';
import { connect, } from 'react-redux';
import { bindActionCreators, } from 'redux';
import { createStructuredSelector, } from 'reselect';
import isObjEqual from 'lodash/isEqual';


@connect(
    createStructuredSelector({
        location: ggRouter.selectors.location,
        locationQuery: ggRouter.selectors.locationQuery,
        routeProps: ggRouter.selectors.routeProps,
        order: ggOrder.selectors.orderActive,
    }),
    dispatch => ({
        orderActions: bindActionCreators(ggOrder.actions, dispatch),
    })
)
export default class OrderStateStepWrap extends Component {

    constructor(props) {
        super(props);

        this.updateOrderStepState = this.updateOrderStepState.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.order && nextProps.order.id) {
            if (!isObjEqual(this.props.location.key, nextProps.location.key)) {
                this.updateOrderStepState(nextProps);
            } else if (this.props.order.id !== nextProps.order.id) {
                this.updateOrderStepState(nextProps);
            }
        }
    }

    updateOrderStepState(props) {
        const
            { orderActions, locationQuery, } = props,
            orderNumber = props.order.number;

        const { orderStep, } = props.routeProps || {};

        if (locationQuery.modal) {
            switch (locationQuery.modal) {
                case 'login':
                    orderActions.updateOrderStepState(orderNumber, {
                        step: 'login',
                    })
                    break;
                case 'signup':
                    orderActions.updateOrderStepState(orderNumber, {
                        step: 'register',
                    })
                    break;
                default:
                    null
            }
        } else if (orderStep) {
            orderActions.updateOrderStepState(orderNumber, orderStep)
                .then(() => orderActions.updateOrderStepSuccess(props.order, orderStep))
        }
    }

    render() {
        return this.props.children;
    }
}
